import Card from 'react-bootstrap/Card';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { UserContext } from '../../context/user-context/user-context';
import { routes } from '../../routes/routes';
import Layout from '../../components/layout/layout';
import { EmailSubscribeService } from '../../services/email-subscribe-service.http';
import { Alert } from 'react-bootstrap';
import { Loading } from '../../components/loading';
import styles from './styles.module.scss';
import { captureError } from '../../lib/sentry';

export const UnsubscribePage = () => {
  const { didToken } = useContext(UserContext);

  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!didToken) return;
    EmailSubscribeService.unsubscribe({ didToken: didToken })
      .then((res) => {
        setIsLoading(false);
      })
      .catch((err) => {
        captureError(err);
        setIsLoading(false);
        setError(
          'Something went wrong with unsubscribing, please try again or contact support@mesh.id'
        );
      });
  }, [didToken]);

  useEffect(() => {
    if (!didToken) {
      history.push(routes.pageResolver() + '?redirect=unsubscribe');
    }
  }, [didToken, history]);
  if (!didToken) return null;

  const loader = (
    <div className="loader-page-wrapper">
      {error ? <Alert variant="danger">{error}</Alert> : <Loading />}
    </div>
  );

  return (
    <Layout>
      {isLoading || error ? (
        loader
      ) : (
        <div className={styles.container}>
          <Card>
            <Card.Body>
              <Card.Title as="h2">Thank you</Card.Title>
              <Card.Text>
                You have been successfully removed from the subscriber list and
                won't receive any further emails from us.
                <br />
                <br />
                Did you unsubscribe by accident?{' '}
                <Link to={routes.subscribe()}>Re-subscribe</Link>
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      )}
    </Layout>
  );
};
